/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { CourseCard } from "./CourseCard";
import BreadTag from "components/dashboard/home/BreadTag";
import { useNavigate } from "react-router-dom";
import math from "../../../../../assets/images/math.png";
import furthermath from "../../../../../assets/images/furthermath.png";
import sine from "../../../../../assets/images/sine.png";
import bookkeep from "../../../../../assets/images/bookkeep.png";
import chemistry from "../../../../../assets/images/chemistry.png";
import government from "../../../../../assets/images/government.png";
import CustomDropdown from "components/dashboard/forms/button/mock/CustomDropdown";
import { CourseServices } from "services/courses";

const MyCourses = () => {
  const roles = JSON.parse(sessionStorage.getItem("#roles") || "{}");
  const userId = JSON.parse(sessionStorage.getItem("#userId") || "{}");
  const [selectedCategory, setSelectedCategory] = useState("Category");
  const [selectedProduct, setSelectedProduct] = useState("Product");
  const [selectedStatus, setSelectedStatus] = useState("Status");
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [studentCourse, setCourses] = useState([]);
  // const [singleCourse, setSingleCourse]= useState([])
  const [endpoint, setApiEndpoint] = useState("");
  const [bgColor, setBgColor] = useState("");
  const [color, setColor] = useState("");
  const [rateBg, setRateBg] = useState("");
  const [textColor, setTextColor] = useState("");

  useEffect(() => {
    if (roles) {
      if (roles === "student") {
        setBgColor("bg-primary");
        setColor("primary");
        setTextColor("text-primary");
        setRateBg("bg-primary");
        setApiEndpoint("course/all?parameter=student");
      } else if (roles === "teacher") {
        setBgColor("bg-blueColor");
        setColor("blueColor");
        setTextColor("text-blueColor");
        setRateBg("bg-blueColor");
        setApiEndpoint("course/all?parameter=teacher");
      } else {
        setBgColor("bg-greenColor");
        setColor("greenColor");
        setTextColor("text-greenColor");
        setRateBg("bg-greenColor");
        setApiEndpoint("course/all?parameter=guest");
      }
    }
  }, [roles, navigate]);
  const getBorderColorClass = (color) => {
    switch (color) {
      case "primary":
        return "border-b-primary";
      case "blueColor":
        return "border-b-blueColor";
      // Add more cases as needed
      default:
        return "";
    }
  };

  const getTextColorClass = (textColor) => {
    // Define mapping if needed or return directly if textColor is a valid Tailwind class
    return textColor;
  };

  // useEffect(() => {
  //   if (endpoint) {
  //     getEnrollCourses();
  //   }
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [endpoint]);
  useEffect(() => {
    getEnrollCourses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const token = JSON.parse(sessionStorage.getItem("token") || "{}");
  const getEnrollCourses = async () => {
    setLoading(true);
    try {
      const response = await CourseServices.getEnrolledCourse(token, userId);
      // console.log("fetch event", response);
      if (response.data.status === "success") {
        const res = response.data.data.details;
        console.log(response);
        setCourses(res?.rows);
        console.log(res?.rows);
        setLoading(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const statuses = ["ongoing", "completed", "saved"];
  const [courseStatus, setCourseStatus] = useState("ongoing");

  const handleViewClick = (id) => {
    const selectedCourse = studentCourse.find(
      (course) => course.course.id === id
    );
    navigate("../my-courses/course-details", {
      state: { courseData: selectedCourse }, // Pass the entire row data as state
    });
    localStorage.setItem("#courseRow", JSON.stringify(selectedCourse.id));
    console.log("View course Detail", selectedCourse.id);
  };

  // const filteredData = studentCourse.filter((item) => item.status === courseStatus);

  const payload = {
    category: selectedCategory !== "Category" ? selectedCategory : null,
    product: selectedProduct !== "Product" ? selectedProduct : null,
    status: selectedStatus !== "Status" ? selectedStatus : null,
  };
  console.log("Payload:", payload);
  return (
    <div className="p-6 bg-gray-100 flex-1 overflow-auto">
      <BreadTag
        title={"Discover All"}
        item1={"dashboard"}
        item3={"My courses"}
        onClick1={() => navigate("../home")}
        onClick3={() => navigate("../my-courses/discover-all")}
      />
      <div className="flex items-center gap-2">
        sort by:
        <CustomDropdown
          options={["Category 1", "Category 2", "Category 3"]}
          selected={selectedCategory}
          onSelect={(category) => setSelectedCategory(category)}
        />
        <CustomDropdown
          options={["Product 1", "Product 2", "Product 3"]}
          selected={selectedProduct}
          onSelect={(product) => setSelectedProduct(product)}
        />
        <CustomDropdown
          options={["Pending", "Confirmed", "Cancelled"]}
          selected={selectedStatus}
          onSelect={(status) => setSelectedStatus(status)}
        />
      </div>
      <div className="flex gap-12 py-4 font-semibold items-center text-sm">
        {statuses.map((status) => (
          <button
            className={`px-6 py-2 text-[16px] font-ManropeSemibold leading-[24px] pb-[4px] capitalize font-medium ${
              status === courseStatus
                ? `transition-all duration-100 border-b-4 ${getBorderColorClass(
                    color
                  )} ${getTextColorClass(textColor)}`
                : "bg-none text-neutral"
            }`}
            key={status}
            onClick={() => setCourseStatus(status)}
          >
            {status}
          </button>
        ))}
      </div>
      <div className="h-full overflow-y-auto">
        {studentCourse?.length > 0 ? (
          <div className="grid gap-6 lg:grid-cols-4 md:grid-cols-3 grid-cols-1">
            {studentCourse.map((course) => (
              <CourseCard
                key={course?.course?.id}
                {...course.course}
                handleViewClick={handleViewClick}
              />
            ))}
          </div>
        ) : (
          <div className="flex justify-center items-center h-60 border-2 border-dashed border-gray-300 rounded-lg">
            <p className="text-gray-500">No enrolled courses yet</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyCourses;
